module.exports = __webpack_public_path__ + "static/img/gongjianhui.b8ab559.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gongjianhui.png
// module id = Mzk2
// module chunks = 19